import React from 'react';
import { Query } from '@apollo/client/react/components';

import JobVaultShowPageQuery from 'buyside/graphql/queries/JobVaultShow';
import JobVaultShowPageCurrentUserQuery from 'buyside/graphql/queries/JobVaultShowCurrentUser';

import JobVaultShowPage from 'buyside/components/presentation/JobVaultShowPage/jobVaultShowPage';

const JobVaultShowPageContainer = ({ jobPostId }) => (
  <Query query={JobVaultShowPageCurrentUserQuery}>
    {({ loading: userLoading, error: userError, data: userData = {} }) => {
      return (
        <Query query={JobVaultShowPageQuery} variables={{ jobPostId }}>
          {({ loading, error, data: jobData = {} }) => {
            return (
              <JobVaultShowPage
                loading={loading || userLoading}
                userError={userError}
                error={error}
                currentUser={userData.currentUser}
                jobPost={jobData.jobPost}
              />
            );
          }}
        </Query>
      );
    }}
  </Query>
);

export default JobVaultShowPageContainer;
